import {initFacilityModals} from '../modules/modal.js';

initFacilityModals();
